import React from "react";
import { Form } from "react-bootstrap";

const FilterComponent = ({filter,setFilter,setCurrentPage}) => {
    return (
      <Form.Group className="my-auto">
      {/* <Form.Label>{ProductString.action}</Form.Label> */}
      <Form.Control
        as="select"
        size="sm"
        value={filter}
        onChange={(e) => {
          setCurrentPage(1);
          setFilter(e.target.value);
        }}
      >
        <option value="">Tutto</option>
        <option value="filter_is_suspended=false&filter_is_expired=false">
          Attivo
        </option>
        <option value="filter_is_suspended=true&filter_is_expired=false">
          Sospeso
        </option>
        <option value="filter_is_expired=true">
          Disattivo
        </option>
      </Form.Control>
    </Form.Group>
    )
  }

export default FilterComponent;